import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { PromotionScheduleListContainer } from '../../containers/promotion/PromotionScheduleListContainer';
import { PROMOTION_SCHEDULE_LIST_PAGE_NAME } from '../../views/promotion/schedule/constants';

/**
 * 프로모션 리스트 페이지 (AMZUWEB-682).
 *
 * 타임라인이 "훑고 옮기는" 화면이라면 여기는 **찾고 뽑는** 화면이다.
 * 필터가 URL 에 남아 걸린 조건 그대로 링크를 주고받을 수 있다.
 */
const PromotionScheduleList = (): React.JSX.Element => {
  return (
    <PageTemplate pageName={PROMOTION_SCHEDULE_LIST_PAGE_NAME}>
      <PromotionScheduleListContainer />
    </PageTemplate>
  );
};

export default PromotionScheduleList;
